import { Controller } from "@hotwired/stimulus"

// Attached to each post's Quote button, not to the editor: the post cards sit
// outside the reply form, so a forum-editor action on them would never fire.
// This reaches the textarea directly instead.
//
// The source markdown is fetched on click rather than inlined into a data
// attribute — a body can run to 50,000 characters, and shipping every one of
// them twice to every visitor is a lot of markup for a button most never press.
export default class extends Controller {
  static values = { url: String }

  async insert(event) {
    event.preventDefault()

    const editor = document.querySelector('[data-forum-editor-target="editor"]')
    if (!editor) return

    let body, author
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      ;({ body, author } = await response.json())
    } catch {
      return
    }

    if (!body) return

    const quoted = body
      .split("\n")
      .map((line) => `> ${line}`)
      .join("\n")

    const attribution = author ? `**@${author}** wrote:\n` : ""
    const separator = editor.value.length > 0 && !editor.value.endsWith("\n\n") ? "\n\n" : ""

    editor.value += `${separator}${attribution}${quoted}\n\n`
    editor.selectionStart = editor.selectionEnd = editor.value.length
    editor.focus()
    editor.scrollIntoView({ behavior: "smooth", block: "center" })
  }
}
